import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/servicelist',
    name: 'servicelist',
    component: () => import('@/views/ServiceList.vue'),
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/NewsView.vue'),
  },
  {
    path: '/news/detail',
    name: 'newsDetail',
    component: () => import('@/views/NewsDetail.vue')
  },
  {
    path: '/patent',
    name: 'patent',
    component: () => import('@/views/PatentView.vue')
  },
  {
    path: '/advancedsearch',
    name: 'advancedsearch',
    component: () => import('@/views/AdvancedSearch')
  },
  {
    path: '/advancedsearchls',
    name: 'advancedsearchls',
    component: () => import('@/views/AdvancedSearchList')
  },
  {
    path: '/patent/detail',
    name: 'patentDetail',
    component: () => import('@/views/PatentDetail.vue'),
  },
  {
    path: '/stock',
    name: 'stock',
    component: () => import('@/views/StockKnowledge.vue')
  },
  {
    path: '/school',
    name: 'school',
    component: () => import('@/views/SchoolView.vue')
  },
  {
    path: '/user_entrance',
    name: 'user_entrance',
    component: () => import('@/views/UserEntrance.vue')
  },
  {
    path: '/technical_demander',
    name: 'technical_demander',
    component: () => import('@/views/TechnicalDemander.vue')
  },
  {
    path: '/charts',
    name: 'charts',
    component: () => import('@/views/ChartsView/ChartsView.vue')
  },
  {
    path: '/chartsdetail',
    name: 'chartsDetail',
    component: () => import('@/views/ChartsView/ChartDetail.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  routes
})

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
